import { spaceCaseToCamelCase } from '@shared/fondof-fn/string/spaceCasetoCamelCase'
import type { ButtonVariant } from '@storefront-satch/components/atoms/button/types'

export const spaceCaseVariantToCamelCaseVariant = (
  spaceCaseVariant: ButtonVariant
) => spaceCaseToCamelCase(spaceCaseVariant)
